import { GET_FAB_SURGE_FILTER, GET_FAB_SURGE_FILTER_SUCCESS, GET_FAB_SURGE_FILTER_ERROR, GET_FAB_SURGE_FILTER_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetLedgerFilter = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAB_SURGE_FILTER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_FAB_SURGE_FILTER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_FAB_SURGE_FILTER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_FAB_SURGE_FILTER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetLedgerFilter;
